import React from 'react';
import PropTypes from 'prop-types';

const WarningIcon = ({ size = 18, color = '#ECCA1D' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 100 100" fill="none">
    <path fill={color} d="M98,76.7L60.1,11.1C58,7.5,54.1,5.2,50,5.2s-8,2.2-10.1,5.8L1.7,77.3c-2.1,3.6-2.1,8.1,0,11.7c2.1,3.6,5.9,5.8,10.1,5.8h76.5c6.4,0,11.7-5.2,11.7-11.7C99.9,80.8,99.2,78.6,98,76.7z M88.2,87H11.8c-1.4,0-2.7-0.7-3.4-1.9c-0.7-1.2-0.7-2.7,0-3.9L46.6,15c0.7-1.2,2-1.9,3.4-1.9c1.4,0,2.7,0.7,3.4,1.9l37.9,65.7c0,0.1,0.1,0.2,0.1,0.2c0.4,0.6,0.7,1.4,0.7,2.2C92.1,85.2,90.4,87,88.2,87z M50,65.5c2.4,0,4.3-1.9,4.3-4.3V38.6c0-2.4-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3v22.6C45.7,63.5,47.6,65.5,50,65.5z M50,68c-1.5,0-2.9,0.6-3.9,1.6c-1,1-1.6,2.5-1.6,3.9c0,1.5,0.6,2.9,1.6,3.9c1,1,2.5,1.6,3.9,1.6c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.5,1.6-3.9c0-1.5-0.6-2.9-1.6-3.9C52.9,68.6,51.5,68,50,68z" />
  </svg>
);

WarningIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default WarningIcon;
